import { useMemo, useState } from "react";
import { useNavigate } from "react-router";

import { Button, ButtonStyle, ConfirmModal, DetailCardSection, Modal } from "@prequel/shared-components";

import { useDeleteDatalake } from "@/api/import/datalakes";
import DangerZone from "@/components/DangerZone";
import { useDatalakeContext } from "@/pages/import/DatalakesPage/DatalakePage";

const DatalakeAdmin = () => {
  const navigate = useNavigate();
  const { datalake } = useDatalakeContext();
  const deleteDatalake = useDeleteDatalake();
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const onConfirmDelete = () => {
    setShowDeleteModal(false);
    deleteDatalake.mutate(datalake.id);
  };

  const dangerZoneActions = useMemo(
    () => [
      {
        label: "Delete datalake",
        description:
          "This action cannot be undone. All associated Datasets and Providers must be deleted before this Datalake can be deleted.",
        buttonText: "Delete datalake",
        onClick: () => setShowDeleteModal(true),
      },
    ],
    [],
  );

  return (
    <>
      <Modal open={showDeleteModal} onClose={() => setShowDeleteModal(false)}>
        <ConfirmModal
          title="Delete datalake"
          message="Are you sure you want to delete this datalake? This action cannot be undone."
          onConfirm={onConfirmDelete}
          confirmButtonText="Delete"
          onCancel={() => setShowDeleteModal(false)}
        />
      </Modal>

      <DetailCardSection title="Edit datalake">
        <p className="mb-3 text-sm text-stone-600">
          Update the datalake&apos;s connection settings, region, or service-account binding.
        </p>
        <Button
          text="Edit datalake"
          type={ButtonStyle.SECONDARY}
          onClick={() => navigate(`/import/datalakes/${datalake.id}/edit`)}
        />
      </DetailCardSection>

      <DangerZone actions={dangerZoneActions} type="card" />
    </>
  );
};

export default DatalakeAdmin;
